/* ==========================================================================
   RasCommerce — wishlist & compare

   Both lists live in the visitor's browser, so no app or customer account is
   required. Product handles are stored and rendered on demand.
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});

  var WISHLIST_KEY = 'rc:wishlist';
  var COMPARE_KEY = 'rc:compare';
  var MAX_COMPARE = 4;

  /* ------------------------------------------------------------- Storage */

  function read(key) {
    var list = RC.storage.get(key, []);
    return Array.isArray(list) ? list : [];
  }

  function write(key, list) {
    RC.storage.set(key, list);
  }

  function toggle(key, handle, max) {
    var list = read(key);
    var index = list.indexOf(handle);

    if (index > -1) {
      list.splice(index, 1);
      write(key, list);
      return { added: false, list: list };
    }

    if (max && list.length >= max) {
      return { added: false, list: list, rejected: true };
    }

    list.push(handle);
    write(key, list);
    return { added: true, list: list };
  }

  /* ---------------------------------------------------------------- View */

  function syncButtons() {
    var wishlist = read(WISHLIST_KEY);
    var compare = read(COMPARE_KEY);

    document.querySelectorAll('[data-rc-wishlist]').forEach(function (button) {
      var active = wishlist.indexOf(button.dataset.productHandle) > -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      var tooltip = button.querySelector('.tooltip');
      if (tooltip) {
        tooltip.textContent = active ? RC.strings.wishlistRemove : RC.strings.wishlistAdd;
      }
    });

    document.querySelectorAll('[data-rc-compare]').forEach(function (button) {
      var active = compare.indexOf(button.dataset.productHandle) > -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('[data-rc-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;
    });

    document.querySelectorAll('[data-rc-compare-count]').forEach(function (el) {
      el.textContent = compare.length;
    });
  }

  RC.wishlist = {
    all: function () {
      return read(WISHLIST_KEY);
    },
    has: function (handle) {
      return read(WISHLIST_KEY).indexOf(handle) > -1;
    },
    clear: function () {
      write(WISHLIST_KEY, []);
      syncButtons();
    }
  };

  RC.compare = {
    all: function () {
      return read(COMPARE_KEY);
    },
    clear: function () {
      write(COMPARE_KEY, []);
      syncButtons();
      /* Both views must refresh — clearing only re-rendered the drawer, so the
         compare page kept showing products that were no longer stored. */
      renderCompareDrawer();
      renderComparePage();
    }
  };

  /* --------------------------------------------------------------- Events */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rc-wishlist]');
    if (!button) return;

    event.preventDefault();
    var handle = button.dataset.productHandle;
    if (!handle) return;

    var result = toggle(WISHLIST_KEY, handle);
    syncButtons();

    RC.toast(result.added ? RC.strings.wishlistAdd : RC.strings.wishlistRemove, 'success', 2000);

    if (!result.added && document.querySelector('[data-rc-wishlist-page]')) {
      renderWishlistPage();
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rc-compare]');
    if (!button) return;

    var handle = button.dataset.productHandle;
    if (!handle) return;

    var result = toggle(COMPARE_KEY, handle, MAX_COMPARE);

    if (result.rejected) {
      event.preventDefault();
      RC.toast(RC.strings.maxCompare, 'error');
      return;
    }

    syncButtons();
    renderCompareDrawer();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-rc-compare-clear]')) {
      event.preventDefault();
      RC.compare.clear();
    }
    if (event.target.closest('[data-rc-wishlist-clear]')) {
      event.preventDefault();
      RC.wishlist.clear();
      renderWishlistPage();
    }

    /* Remove a single product from the comparison. */
    var remove = event.target.closest('[data-rc-compare-remove]');
    if (remove) {
      event.preventDefault();
      var handle = remove.getAttribute('data-rc-compare-remove');
      var list = read(COMPARE_KEY).filter(function (h) { return h !== handle; });
      write(COMPARE_KEY, list);
      syncButtons();
      renderCompareDrawer();
      renderComparePage();
    }
  });

  /* ------------------------------------------------------------ Rendering */

  function fetchCards(handles, target, emptyMessage, cardWrapper) {
    if (!target) return;

    if (!handles.length) {
      target.innerHTML = '<p class="rc-empty-state">' + emptyMessage + '</p>';
      return;
    }

    target.innerHTML = '<div class="text-center py-4"><span class="rc-spinner"></span></div>';

    var requests = handles.map(function (handle) {
      return RC.fetchText(RC.routes.root + 'products/' + handle + '?section_id=product-card-fragment')
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-rc-card-fragment]');
          return card ? card.innerHTML : '';
        })
        .catch(function () {
          return '';
        });
    });

    Promise.all(requests).then(function (cards) {
      var valid = cards.filter(Boolean);
      if (!valid.length) {
        target.innerHTML = '<p class="rc-empty-state">' + emptyMessage + '</p>';
        return;
      }
      target.innerHTML = valid.map(cardWrapper || function (c) { return c; }).join('');
      syncButtons();
    });
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-rc-wishlist-page]');
    if (!page) return;

    fetchCards(
      read(WISHLIST_KEY),
      page,
      page.dataset.emptyText || 'Your wishlist is empty.',
      function (card) {
        return '<div class="grid-item">' + card + '</div>';
      }
    );
  }

  /* Product JSON drives the comparison: it carries price, availability,
     vendor, type and options without needing a rendered section. */
  function loadProducts(handles) {
    return Promise.all(
      handles.map(function (handle) {
        return RC.fetchJSON(RC.routes.root + 'products/' + handle + '.js')
          .then(function (p) { return p; })
          .catch(function () { return null; });
      })
    ).then(function (list) {
      return list.filter(Boolean);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* A real side-by-side table rather than a row of product cards. */
  function buildCompareTable(products) {
    var optionNames = [];
    products.forEach(function (p) {
      (p.options || []).forEach(function (o) {
        var name = typeof o === 'string' ? o : o.name;
        if (name && name !== 'Title' && optionNames.indexOf(name) === -1) optionNames.push(name);
      });
    });

    function headCell(p) {
      var img = p.featured_image
        ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">'
        : '';
      return '<th scope="col">' +
        '<button type="button" class="rc-compare-remove" data-rc-compare-remove="' + esc(p.handle) + '" aria-label="Remove">&times;</button>' +
        '<a class="rc-compare-thumb" href="' + esc(p.url) + '">' + img + '</a>' +
        '<a class="rc-compare-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '</th>';
    }

    function row(label, cellFn) {
      return '<tr><th scope="row">' + esc(label) + '</th>' +
        products.map(function (p) { return '<td>' + cellFn(p) + '</td>'; }).join('') +
        '</tr>';
    }

    /* --rc-cols lets the CSS cap the table width to the number of products. */
    var html = '<div class="rc-compare-scroll"><table class="rc-compare-table" style="--rc-cols:' + products.length + '">';
    html += '<thead><tr><td class="rc-compare-corner"></td>' + products.map(headCell).join('') + '</tr></thead><tbody>';

    html += row('Price', function (p) {
      var price = '<span class="rc-compare-price">' + RC.formatMoney(p.price) + '</span>';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        price += ' <s class="rc-compare-was">' + RC.formatMoney(p.compare_at_price) + '</s>';
      }
      return price;
    });

    html += row('Availability', function (p) {
      return p.available
        ? '<span class="rc-compare-yes">In stock</span>'
        : '<span class="rc-compare-no">Out of stock</span>';
    });

    if (products.some(function (p) { return p.vendor; })) {
      html += row('Brand', function (p) { return esc(p.vendor || '—'); });
    }

    if (products.some(function (p) { return p.type; })) {
      html += row('Type', function (p) { return esc(p.type || '—'); });
    }

    optionNames.forEach(function (name) {
      html += row(name, function (p) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : o.name;
          if (n === name) idx = i;
        });
        if (idx === -1) return '—';
        var values = [];
        (p.variants || []).forEach(function (v) {
          var val = v.options ? v.options[idx] : null;
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        return values.length ? esc(values.join(', ')) : '—';
      });
    });

    html += row('', function (p) {
      if (!p.available) {
        return '<span class="tf-btn btn-outline radius-3 disabled">Out of stock</span>';
      }
      if (p.variants && p.variants.length === 1) {
        return '<button type="button" class="tf-btn btn-fill radius-3 justify-content-center" ' +
          'data-rc-quick-add data-variant-id="' + p.variants[0].id + '"><span>Add to cart</span></button>';
      }
      return '<a class="tf-btn btn-fill radius-3 justify-content-center" href="' + esc(p.url) + '"><span>Choose options</span></a>';
    });

    html += '</tbody></table></div>';
    return html;
  }

  function renderComparePage() {
    var page = document.querySelector('[data-rc-compare-page]');
    if (!page) return;

    var handles = read(COMPARE_KEY);
    var empty = page.dataset.emptyText || 'No products to compare yet.';

    if (!handles.length) {
      page.innerHTML = '<p class="rc-empty-state">' + empty + '</p>';
      return;
    }

    page.innerHTML = '<div class="text-center py-4"><span class="rc-spinner"></span></div>';

    loadProducts(handles).then(function (products) {
      page.innerHTML = products.length ? buildCompareTable(products) : '<p class="rc-empty-state">' + empty + '</p>';
      syncButtons();
    });
  }

  /* The drawer stays a compact shortlist; the table lives on the page. */
  function renderCompareDrawer() {
    var target = document.querySelector('[data-rc-compare-items]');
    if (!target) return;

    var handles = read(COMPARE_KEY);

    if (!handles.length) {
      target.innerHTML = '<p class="rc-compare-empty text-center py-4">No products to compare yet.</p>';
      return;
    }

    target.innerHTML = '<div class="text-center py-3"><span class="rc-spinner"></span></div>';

    loadProducts(handles).then(function (products) {
      if (!products.length) {
        target.innerHTML = '<p class="rc-compare-empty text-center py-4">No products to compare yet.</p>';
        return;
      }
      target.innerHTML = products.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '';
        return '<div class="rc-compare-mini">' +
          '<a class="rc-compare-mini-img" href="' + esc(p.url) + '">' + img + '</a>' +
          '<div class="rc-compare-mini-info">' +
            '<a class="rc-compare-mini-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="rc-compare-mini-price">' + RC.formatMoney(p.price) + '</span>' +
          '</div>' +
          '<button type="button" class="rc-compare-remove" data-rc-compare-remove="' + esc(p.handle) + '" aria-label="Remove">&times;</button>' +
          '</div>';
      }).join('');
      syncButtons();
    });
  }

  /* ----------------------------------------------------------------- Init */

  RC.onSectionLoad(function () {
    syncButtons();
    renderWishlistPage();
    renderComparePage();
  });

  document.addEventListener('rc:cart:rendered', syncButtons);

  var compareDrawer = document.getElementById('compare');
  if (compareDrawer) {
    compareDrawer.addEventListener('show.bs.offcanvas', renderCompareDrawer);
  }
})();
